import type { TFunction } from "i18next";
import type { ActivitySummary } from "../../utils/activitySummary";

function joinList(items: string[], language: string): string {
    const ListFormat = (Intl as { ListFormat?: new (locale: string, options: object) => { format: (list: string[]) => string } }).ListFormat;
    if (ListFormat) return new ListFormat(language, { style: "long", type: "conjunction" }).format(items);
    return items.length < 2 ? items.join("") : `${items.slice(0, -1).join(", ")} & ${items[items.length - 1]}`;
}

function capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function activitySummaryCopy(summary: ActivitySummary, t: TFunction, language: string) {
    // "days" is the only period parameterised by a count - the exact
    // "N days ago" phrasing behind activitySummary.periods.days(_one/_other).
    const periodOptions = summary.period === "days" ? { count: summary.dayCount } : undefined;
    const period = t(`activitySummary.periods.${summary.period}`, periodOptions);

    if (summary.kind === "single") {
        return {
            heading: t(`activitySummary.single.${summary.primary.id}`, { period }),
            detail: summary.wider
                ? t(`activitySummary.wider.${summary.wider.period}`, { count: summary.wider.count })
                : t("activitySummary.keepGoing"),
        };
    }

    if (summary.kind === "many") {
        return {
            heading: t(`activitySummary.many.${summary.period}`, periodOptions),
            detail: t("activitySummary.manyDetail", { count: summary.activities.length }),
        };
    }

    const names = summary.activities.map((id) => t(`activitySummary.names.${id}`));
    return {
        heading: t("activitySummary.few", { period }),
        detail: capitalize(joinList(names, language === "pt" ? "pt-PT" : "en")),
    };
}
